// @generated by protoc-gen-es v1.7.0 with parameter "target=ts,import_extension=.ts"
// @generated from file plugnmeet_ingress.proto (package plugnmeet, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from '@bufbuild/protobuf';
/**
 * @generated from enum plugnmeet.IngressInput
 */
export var IngressInput;
(function (IngressInput) {
    /**
     * @generated from enum value: RTMP_INPUT = 0;
     */
    IngressInput[IngressInput["RTMP_INPUT"] = 0] = "RTMP_INPUT";
    /**
     * @generated from enum value: WHIP_INPUT = 1;
     */
    IngressInput[IngressInput["WHIP_INPUT"] = 1] = "WHIP_INPUT";
})(IngressInput || (IngressInput = {}));
// Retrieve enum metadata with: proto3.getEnumType(IngressInput)
proto3.util.setEnumType(IngressInput, 'plugnmeet.IngressInput', [
    { no: 0, name: 'RTMP_INPUT' },
    { no: 1, name: 'WHIP_INPUT' },
]);
/**
 * @generated from message plugnmeet.CreateIngressReq
 */
export class CreateIngressReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.IngressInput input_type = 1;
         */
        this.inputType = IngressInput.RTMP_INPUT;
        /**
         * @generated from field: string participant_name = 2;
         */
        this.participantName = '';
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateIngressReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIngressReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIngressReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIngressReq, a, b);
    }
}
CreateIngressReq.runtime = proto3;
CreateIngressReq.typeName = 'plugnmeet.CreateIngressReq';
CreateIngressReq.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'input_type',
        kind: 'enum',
        T: proto3.getEnumType(IngressInput),
    },
    {
        no: 2,
        name: 'participant_name',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
    },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.CreateIngressRes
 */
export class CreateIngressRes extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        /**
         * @generated from field: plugnmeet.IngressInput input_type = 3;
         */
        this.inputType = IngressInput.RTMP_INPUT;
        /**
         * @generated from field: string url = 4;
         */
        this.url = '';
        /**
         * @generated from field: string stream_key = 5;
         */
        this.streamKey = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreateIngressRes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIngressRes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIngressRes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIngressRes, a, b);
    }
}
CreateIngressRes.runtime = proto3;
CreateIngressRes.typeName = 'plugnmeet.CreateIngressRes';
CreateIngressRes.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'input_type',
        kind: 'enum',
        T: proto3.getEnumType(IngressInput),
    },
    { no: 4, name: 'url', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 5, name: 'stream_key', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
